import { generate } from "@ant-design/colors";
export function getStyleByBaseColors(theme, baseColors, backgroundColor) {
  return (theme === "dark" ? getDarkStyle : getLightStyle)("".concat(getCssVariableDefinitionsByPalettes(generatePalettes(baseColors, theme, backgroundColor), theme), "\n").concat(getMigratedCssVariableDefinitions(theme, baseColors, backgroundColor)));
}
export function getStyleByBrandColor(theme, brandColor) {
  return (theme === "dark" ? getDarkStyle : getLightStyle)(getCssVariableDefinitionsByBrand(brandColor));
}
export function getStyleByVariables(theme, variables) {
  return (theme === "dark" ? getDarkStyle : getLightStyle)(getCssVariableDefinitionsByVariables(variables));
}
function getLightStyle(cssVariableDefinitions) {
  return ":root,\n[data-override-theme=\"light\"] {\n".concat(cssVariableDefinitions, "}");
}
function getDarkStyle(cssVariableDefinitions) {
  return "html[data-theme=\"dark-v2\"],\n[data-override-theme=\"dark-v2\"] {\n".concat(cssVariableDefinitions, "}");
}
function getCssVariableDefinitionsByPalettes(palettes, theme) {
  return Object.entries(palettes).flatMap(_ref => {
    var [colorName, palette] = _ref;
    ensureBaseColorName(colorName);
    return palette.map((color, index) => ["  --palette-".concat(colorName, "-").concat(index + 1, "-channel: ").concat(getRgbChannel(color), ";")].concat(theme === "dark" ? [] : "  --palette-".concat(colorName, "-").concat(index + 1, ": rgb(var(--palette-").concat(colorName, "-").concat(index + 1, "-channel));")).join("\n"))
    // Concat an empty string to make a double-line-break for each group of color name.
    .concat("");
  }).join("\n");
}
function generatePalettes(baseColors, theme, backgroundColor) {
  return Object.fromEntries(Object.entries(baseColors).map(_ref2 => {
    var [colorName, baseColor] = _ref2;
    return [colorName, generate(baseColor, theme === "dark" ? {
      theme,
      backgroundColor
    } : undefined)];
  }));
}
function getCssVariableDefinitionsByBrand(color) {
  if (typeof color === "string") {
    return "  --color-brand: ".concat(color, ";\n");
  }
  return ["  --color-brand: ".concat(color.default, ";"), "  --color-brand-hover: ".concat(color.hover, ";"), "  --color-brand-active: ".concat(color.active, ";"), ""].join("\n");
}
function getCssVariableDefinitionsByVariables(variables) {
  return Object.entries(variables).map(_ref3 => {
    var [name, color] = _ref3;
    ensureCssVariableName(name);
    return "  ".concat(name, ": ").concat(color, ";");
  }).concat("").join("\n");
}
function ensureCssVariableName(name) {
  if (!/^--[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/.test(name)) {
    throw new Error("Invalid css variable name: ".concat(JSON.stringify(name)));
  }
}
function ensureBaseColorName(name) {
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name)) {
    throw new Error("Invalid base color name: ".concat(JSON.stringify(name)));
  }
}
function getMigratedCssVariableDefinitions(theme, baseColors, backgroundColor) {
  var migrateMap = {
    green: "green",
    red: "red",
    blue: "blue",
    orange: "orange",
    cyan: "cyan",
    purple: "purple",
    geekblue: "indigo"
  };
  return Object.entries(migrateMap).flatMap(_ref4 => {
    var [legacyColorName, newColorName] = _ref4;
    return ["  --theme-".concat(legacyColorName, "-color-rgb-channel: ").concat(getRgbChannel(getActualBaseColor(baseColors[newColorName], theme, backgroundColor)), ";"), ...(theme === "dark" ? [] : ["  --theme-".concat(legacyColorName, "-color: var(--palette-").concat(newColorName, "-6);"), "  --theme-".concat(legacyColorName, "-border-color: var(--palette-").concat(newColorName, "-3);")]), "  --theme-".concat(legacyColorName, "-background: var(--palette-").concat(newColorName, "-").concat(theme === "dark" ? 2 : 1, ");"), ""];
  }).join("\n");
}
function getRgbChannel(color) {
  return color.match(/[0-9a-fA-F]{2}/g).map(hex => parseInt(hex, 16)).join(", ");
}
function getActualBaseColor(baseColor, theme, backgroundColor) {
  return theme === "dark" ? generate(baseColor, {
    theme,
    backgroundColor
  })[5] : baseColor;
}
//# sourceMappingURL=index.js.map